import React from "react";
import classNames from "classnames";

import styles from "./styles.module.scss";

const DotDivider = ({classes="", style}) => (
  <div className={classNames(classes)} style={style}>
    <div className={classNames(styles.dotDivider)} />
  </div>
);

export default DotDivider;
